import {axios} from "@/utils"

const endpoints = {
    get_medias: '/v3/medias/',
    get_galleries: '/v3/checkins/{checkin_id}/galleries/',
    get_gallery_medias: '/v3/checkins/{checkin_id}/galleries/{gallery_id}/medias/',
}

export default {
    async getMedias(params) {
        const response = await axios.get(endpoints.get_medias, {params})
        return response.data
    },
    async getGalleries(checkin_id) {
        const response = await axios.get(endpoints.get_galleries.replace('{checkin_id}', checkin_id))
        return response.data
    },
    async getMediasByGallery(checkin_id, gallery_id, params) {
        const response = await axios.get(endpoints.get_gallery_medias.replace('{checkin_id}', checkin_id).replace('{gallery_id}', gallery_id), {params})
        return response.data
    }
}